(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('[data-show-media]');
  if (!button) return;
  const gallery = button.closest('[data-product-section]').querySelector('[data-product-gallery]');
  const item = Array.from(gallery.children).find(node => node.dataset.mediaId === button.dataset.showMedia);
  if (item) gallery.scrollTo({left:item.offsetLeft,behavior:'instant'});
});

  } catch(e) { console.error(e); }
})();
})();
